export enum Popups {
    none,
    endExitGame,
    endExitGameNotification,
    judgeRules,
    rules,
    removePlayer,
    waitingForHost,
    basicInfo
}